module.exports = __webpack_public_path__ + "static/media/CareerMasterClass.82649cc4.jpg";